export function validateMobile(mobile) {
	return new RegExp(/^[6-9]\d{9}$/).test(mobile)
}

export function validateOTP(otp) {
	return otp && `${otp}`.length === 4
}

export function getCookie(name) {
	var value = '; ' + document.cookie
	var parts = value.split('; ' + name + '=')
	if (parts.length == 2) return parts.pop().split(';').shift()
}

export function validateEmail(email) {
	var re =
		/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(email)
}
